import React from 'react'

import CommunityAgreementFR from './fr'
import CommunityAgreementEN from './en'
import CommunityAgreementIT from './it'
import CommunityAgreementES from './es'
import CommunityAgreementDE from './de'

function CommunityAgreement({ locale }) {
  switch (locale) {
    case 'fr-FR':
      return <CommunityAgreementFR />
    case 'it-IT':
      return <CommunityAgreementIT />
    case 'es-ES':
      return <CommunityAgreementES />
    case 'de-DE':
      return <CommunityAgreementDE />
    case 'en-US':
    default:
      return <CommunityAgreementEN />
  }
}

export default CommunityAgreement
